// Story 1.30 — TanStack Query hook for GET /api/v1/admin/bulletin/posts/:id.

import { useQuery } from "@tanstack/react-query";

import { attachRequestIdToScope } from "../../lib/api-client";
import type { BulletinPostListItem } from "./useAdminBulletinList";

export type BulletinDetailResponse = {
  data: BulletinPostListItem;
};

async function fetchBulletinDetail(id: string): Promise<BulletinDetailResponse> {
  const response = await fetch(`/api/v1/admin/bulletin/posts/${id}`, {
    credentials: "include",
  });
  attachRequestIdToScope(response);
  if (!response.ok) {
    let message = `Admin bulletin detail fetch failed (HTTP ${response.status})`;
    try {
      const raw = await response.json();
      if (raw?.error?.message) message = raw.error.message;
    } catch {
      // body not JSON
    }
    throw new Error(message);
  }
  return (await response.json()) as BulletinDetailResponse;
}

export function useAdminBulletinDetail(id: string | undefined) {
  return useQuery<BulletinDetailResponse, Error>({
    queryKey: ["admin-bulletin-detail", id],
    queryFn: () => fetchBulletinDetail(id as string),
    enabled: !!id,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
  });
}
